import React  from 'react'
import About1 from "../../../assets/images/about-1.jpg"
// import About2 from "../../../assets/images/about-2.jpg"
import Shape1 from "../../../assets/images/shape-11.png"
// import Signature from "../../../assets/images/signature-1.png"
import { Link } from 'react-router-dom'
import { config } from '../config'
import Bredcrum from '../../common/Bredcrum'
import secureLocalStorage from 'react-secure-storage'
import team3 from "../../../assets/images/team/team-1.jpg"

const InstructorDetails = () => {

    const instructorData = secureLocalStorage.getItem("Instructor_Details");

    return (
        <>
            <Bredcrum
                heading={'Instructor Profile'}
                path={[
                    { name: 'Instructor Profile', path: 'instructor' },
                ]}
            />      

            <section className="about-section">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-8 col-md-12 col-sm-12 big-column ">
                            <div className="inner-box">
                                <div className="title-text mb-2 mb-xl-5 mt-3 mt-xl-0">
                                    <h2>{instructorData?.name}</h2>
                                </div>
                                <div className="row clearfix">
                                    <div className="col-lg-6 col-md-6 col-sm-12 image-column">
                                        <div className="image-box d-md-block d-none">
                                            <figure className="image">
                                                <img src={About1} alt="" />
                                            </figure>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 content-column">
                                        <div className="content-box">
                                            <h5 className='fw-semibold mb-4'>Instructor</h5>
                                            {/* <h3 className='display-6 mb-3 fw-semibold'>{instructorData?.name}</h3> */}
                                            <div className="text">
                                                <p>{instructorData?.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12 small-column position-relative">
                            <div className="image-box">
                                <div className="shape" style={{ backgroundImage: `url(${Shape1})` }}></div>
                                <figure className="image"><img src={instructorData?.image ? instructorData?.imageUrl : team3 } alt="" /></figure>
                                <div className='d-flex my-5'>
                                    <div className="author">
                                        <h5 className='mb-2'>Location</h5>
                                        <span className="designation">{instructorData?.address}</span>
                                    </div>
                                    <div className="author ms-md-5 ms-4">
                                        <h5 className='mb-2'>Car Type:</h5>
                                        <span className="designation">Manual / Automatic </span>
                                    </div>
                                </div>
                                <div className="btn-box">
                                    <Link to={`${config.appUrl}book-a-lesson`}
                                        state={{ data: instructorData?.id }}
                                        className="theme-btn btn-two">
                                        Book Online Now</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default InstructorDetails
